<div class="matero-container-wrap matero-header-above matero-navbar-side" [ngClass]="{
    'matero-sidenav-collapsed': options.sidenavCollapsed && displaySidebar,
    'matero-header-white': !sharedService.darkMode
  }" [dir]="options.dir">
  <ng-progress></ng-progress>

  <!-- Header Above -->

  <app-navbar (toggleSidenav)="sidenav.toggle()" [isMobile]="isMobile"
    (toggleChatbotNotice)="chatbotNotice.toggle()" (user)="userName">>
  </app-navbar>

  <div *ngIf="!production" [ngClass]="{
      watermark: !isMobile,
      'small-watermark': isMobile
    }">
    <span>{{ build }}</span>
  </div>

  <app-timeout *ngIf="useTimeout"></app-timeout>

  <mat-sidenav-container class="matero-container" autosize autoFocus>
    <mat-sidenav #sidenav class="matero-sidenav" [mode]="isMobile ? 'over' : 'side'" [opened]="sidenavOpen()"
      (openedChange)="sidenavOpenedChange($event)" (closedStart)="sidenavCloseStart()" style="
        background-size: 90%;
        background-repeat: no-repeat;
        background-position: center bottom;
        background-image: url(../../assets/images/OHA-Color-min.png);
      ">
      <app-sidebar (toggleCollapsed)="sidenavOpenedChange($event)" [isMobile]="isMobile" [ripple]="!isMobile">
      </app-sidebar>
    </mat-sidenav>

    <mat-sidenav #chatbotNotice position="end" mode="over">
      <app-chatbot></app-chatbot>
    </mat-sidenav>

    <mat-sidenav-content #content class="flex matero-content-wrap">
      <div class="matero-content">
        <router-outlet></router-outlet>
      </div>
      <app-footer *ngIf="!isMobile" class="w-full fixed bottom-0"></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
